export default __webpack_public_path__ + "static/2-dab917ddb0f9813de7f53b8382c93d0b.jpg";